import { State } from '../reducers/rootReducer'
import { SummaryState } from '../reducers/summaryReducer'

const SummarySelector = (state: State): SummaryState => state.summary

export default SummarySelector
